var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('v-header'),_c('router-view'),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }